import React from 'react'
import { Col, Row } from 'reactstrap'
import GitInfo from 'react-git-info/macro';

const BuildDetailsComponent = () => {
    const gitInfo = GitInfo();

    return (
        <Row>
            <Col sm={12}>
                <b>Date:</b> {gitInfo.commit.date}<br />
                <b>Last Commit:</b><small> {gitInfo.commit.message}</small><br />
                <b>Last Hash:</b> {gitInfo.commit.shortHash}<br />
                <b>Branch:</b> {gitInfo.branch}<br />
            </Col>
        </Row>
    )
}

export default BuildDetailsComponent